/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-named-default
import { default as MuiButton, ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

const StyledButton = styled(MuiButton)(({ theme }) => ({
  ':focus': {
    outline: 'none'
  },
  padding: '12px',
  fontSize: theme.typography.CTA1?.fontSize,
  fontWeight: theme.typography.CTA1?.fontWeight
}));

interface IButtonProps extends ButtonProps {
  handleClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  children?: any;
}
function InstavisionButton(props: IButtonProps) {
  const {
    handleClick,
    isLoading,
    isDisabled = false,
    children,
    ...restOfProps
  } = props;
  return (
    <StyledButton
      variant="instavision"
      onClick={handleClick}
      disabled={isDisabled || isLoading}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restOfProps}
    >
      {children}
      {isLoading ? (
        <CircularProgress
          color="inherit"
          size="1rem"
          sx={{ marginLeft: '8px' }}
        />
      ) : null}
    </StyledButton>
  );
}

export default InstavisionButton;
